/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/user_feedback_medium'
export default icon
